import React, { useEffect, useState } from 'react'
import RenderHTML from '../ui-components/RenderHTML'

interface ChipOption {
  id: string
  label: string
}

interface ToggleChipProps {
  options: ChipOption[]
  onSelectionChange: (selectedId: string) => void
  defaultSelectedId?: string
  className?: string
  testLocator?: string
  isLocked?: boolean
}

export const ToggleChip: React.FC<ToggleChipProps> = ({
  options,
  onSelectionChange,
  defaultSelectedId,
  className = '',
  testLocator,
  isLocked = false
}) => {
  const [selectedId, setSelectedId] = useState<string>(defaultSelectedId || options[0]?.id || '')

  const currentOption = options.find((option) => option.id === selectedId) || options[0]

  const handleChipClick = () => {
    if (isLocked) return
    const currentIndex = options.findIndex((option) => option.id === selectedId)
    const newIndex = (currentIndex + 1) % options.length
    const newId = options[newIndex].id
    onSelectionChange(newId)
  }

  useEffect(() => {
    setSelectedId(defaultSelectedId || options[0]?.id || '')
  }, [defaultSelectedId, options.length, options[0]?.id])

  return (
    <div className={`relative ${className}`}>
      <div
        test-locator={testLocator}
        onClick={isLocked ? undefined : handleChipClick}
        className='flex items-center justify-between pl-3 pr-2 pt-[5px] pb-[6px] bg-[#F0F4F7] rounded-[12px] text-[#232323] font-[500] text-[13px] transition-colors duration-200 w-full'
      >
        <span>{currentOption?.label}</span>
        {isLocked ? null : (
          <div className='flex flex-col ml-[2px] mt-[1px] pointer-events-none'>
            <RenderHTML innerHTMLText={ArrowIcon} />
          </div>
        )}
      </div>
    </div>
  )
}

const ArrowIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.35355 1.66476C6.15829 1.44508 5.84171 1.44508 5.64645 1.66476L3.64646 3.91476C3.50346 4.07563 3.46068 4.31756 3.53807 4.52776C3.61546 4.73795 3.79778 4.875 4.00001 4.875H7.99999C8.20222 4.875 8.38454 4.73795 8.46193 4.52776C8.53932 4.31756 8.49654 4.07563 8.35354 3.91476L6.35355 1.66476ZM3.53807 7.47224C3.61546 7.26205 3.79778 7.125 4.00001 7.125H7.99999C8.20222 7.125 8.38454 7.26205 8.46193 7.47224C8.53932 7.68243 8.49654 7.92437 8.35354 8.08524L6.35355 10.3353C6.15829 10.5549 5.84171 10.5549 5.64645 10.3353L3.64646 8.08524C3.50346 7.92437 3.46068 7.68243 3.53807 7.47224Z" fill="#8E9393"/>
</svg>`
